import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72fa60b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tbHead" }, "单位社保", -1))

import { ref, nextTick, computed, onBeforeMount, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import OrderQuery from '@/views/OrderQuery.vue'
import RtList from '@/views/ViewsComponents/RT/RTList.vue'
import salaryMonth from '@/views/ViewsComponents/salary/salaryTemplate.vue'
import dayjs from 'dayjs'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    tableFunc: null,
    isTotal: { type: Boolean },
    searchConfig: null,
    otherParmas: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  tableFunc: any
  isTotal: boolean
  searchConfig: object[]
  otherParmas?: {coTwoOrgId: string}
}

let {
  // 团队余额-根据团队获取信息
  'POST/order_profit/org': fetchList,
  // 团队余额,薪酬穿透
  'POST/salaries/distributes/org/salary': salaryApi,
  // 根据团队id获取团队成本总览
  'POST/house_lease_costs/every_org': every_orgApi
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(props.tableFunc)

const orgBalanceData = computed(() => {
  return MI_tableData.value.map((dataRow, index) => {
    // 累计提交
    dataRow.basicOrderTotal = index === 0 ? dataRow.basicOrder : MI_tableData.value[index - 1].basicOrderTotal + dataRow.basicOrder
    // 累计成本
    dataRow.basicCostTotal = index === 0 ? dataRow.basicCost : MI_tableData.value[index - 1].basicCostTotal + dataRow.basicCost
    // 累计毛利率
    dataRow.profitTotal = !dataRow.basicOrder ? '' : profitFormat(1 - dataRow.basicCostTotal / dataRow.basicOrderTotal)
    // 开单毛利率
    dataRow.confirmProfit = profitFormat(1 - dataRow.confirmCost / dataRow.openOrder)
    // 贡献
    dataRow.contribution = dataRow.basicOrder - dataRow.basicCost - dataRow.salary - dataRow.rent - dataRow.reimbursed - dataRow.reimbursing
    // 累计贡献
    dataRow.contributionTotal = index === 0 ? dataRow.contribution : MI_tableData.value[index - 1].contributionTotal + dataRow.contribution
    // 累计贡献率
    dataRow.contributionRateTotal = !dataRow.basicOrder ? '' : profitFormat(dataRow.contributionTotal / dataRow.basicOrderTotal)
    // 毛利率
    dataRow.profit = profitFormat(1 - dataRow.basicCost / dataRow.basicOrder)
    // 贡献度
    dataRow.contributionRate = !dataRow.basicOrder ? '-' : profitFormat( dataRow.contribution / dataRow.basicOrder)
    return dataRow
  })
})

const searchConfig = ref(props.searchConfig)

onBeforeMount(() => { })

let balanceSearchEle = ref()
let coTwoOrgId = ref<string>('')
const showBalance = (row: {id: number, coTwoOrgId: string}) => {
  coTwoOrgId.value = row.coTwoOrgId
  balanceSearchEle.value.dataObj.update = false
  searchBalance({orgId: row.id, update: false})
}

const searchBalance = (params: any) => {
  fetchData({
    ...params, 
    startDate: dayjs(params.startDate).startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs(params.endDate).endOf('month').format('YYYY-MM-DD')
  }, {timeout: 60000 * 5})
}

// 穿透查看
let fullCurrency = ['CNY', 'USD', 'EUR', 'AUD', 'GBP', 'HKD', 'JPY', 'SGD', 'CAD', 'SGP', 'SEK', 'IDR']
const isShowOrderQuery = ref<boolean>(false)
const orderQueryEle = ref()

const isShowRtList = ref<boolean>(false)
const rtListEle = ref()

const salaryFg = ref<boolean>(false)
const insureFg = ref(false)
const salaryParams: any = reactive({})

const isShowRent = ref<boolean>(false)
let rentTbData: any = ref([])

const swtichPage = (row: any, column: any) => {
  coTwoOrgId.value = row.coTwoOrgId
  // 开单
  if(column.property === 'openOrder'){
    isShowOrderQuery.value = true
    nextTick(() => {
      orderQueryEle.value.searchForm.resetForm()
      orderQueryEle.value.searchForm.dataObj.startTimeFrom = dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD')
      orderQueryEle.value.searchForm.dataObj.startTimeTo = dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD')
      orderQueryEle.value.searchForm.dataObj.currency = fullCurrency
      orderQueryEle.value.searchForm.dataObj.coTwoOrgId = coTwoOrgId.value

      orderQueryEle.value.searchForm.submitHandle()
    })
  }
  // 交付成本
  if(column.property === 'confirmCost'){
    isShowRtList.value = true
    nextTick(() => {
      rtListEle.value.searchForm.dataObj.paymentTimeFrom = dayjs(MI_params.startDate).startOf('year').format('YYYY-MM-DD')
      rtListEle.value.searchForm.dataObj.paymentTimeTo = dayjs(MI_params.endDate).endOf('year').format('YYYY-MM-DD')
      rtListEle.value.searchForm.dataObj.deliverTimeFrom = dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD')
      rtListEle.value.searchForm.dataObj.deliverTimeTo = dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD')

      rtListEle.value.searchForm.dataObj.resourceCurrency = ["CNY", "USD"]
      rtListEle.value.searchForm.dataObj.coTwoOrgId = coTwoOrgId.value
      rtListEle.value.searchForm.dataObj.isNoCalculated = 'false'
      rtListEle.value.searchForm.dataObj.existTestCost = 'false'

      rtListEle.value.searchForm.submitHandle()
    })
  }
  // 提交
  if(column.property === 'basicOrder'){
    isShowOrderQuery.value = true
    nextTick(() => {
      orderQueryEle.value.searchForm.resetForm()
      orderQueryEle.value.searchForm.dataObj.deliverTimeFrom = dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD')
      orderQueryEle.value.searchForm.dataObj.deliverTimeTo = dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD')
      orderQueryEle.value.searchForm.dataObj.currency = fullCurrency
      orderQueryEle.value.searchForm.dataObj.coTwoOrgId = coTwoOrgId.value
  
      orderQueryEle.value.searchForm.submitHandle()
    })
  }
  // 成本
  if(column.property === 'basicCost'){
    isShowRtList.value = true
    nextTick(() => {
      rtListEle.value.searchForm.dataObj.paymentTimeFrom = dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD')
      rtListEle.value.searchForm.dataObj.paymentTimeTo = dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD')

      rtListEle.value.searchForm.dataObj.resourceCurrency = ["CNY", "USD"]
      rtListEle.value.searchForm.dataObj.coTwoOrgId = coTwoOrgId.value
      rtListEle.value.searchForm.dataObj.isNoCalculated = 'false'
      rtListEle.value.searchForm.dataObj.existTestCost = 'false'

      rtListEle.value.searchForm.submitHandle()
    })
  }
  // 薪酬
  if(column.property === 'salary'){
    Object.assign(salaryParams, {
      startDate:  dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD'),
      orgId: row.orgId
    })
    salaryFg.value = true
    
  }
  // 租赁
  if(column.property === 'rent'){
    MI_identify.value = true
    every_orgApi({
      orgId: MI_params.orgId,
      startDate:  dayjs(MI_params.startDate).startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs(MI_params.endDate).endOf('month').format('YYYY-MM-DD'),
    }).then((rep) => {
      rentTbData.value = rep
      isShowRent.value = true
      MI_identify.value = false
    }).then(() => {
      MI_identify.value = false
    })
  }
}

// ----------
const formatNumb = (number: number) => {
  if(!number) return '-';
  // return number.toLocaleString("en-US", {maximumFractionDigits: 0,minimumFractionDigits: 0})
  return Math.floor(number).toLocaleString()
}

const profitFormat = (number: number) => {
  if(!number) return '-';
  return (number * 100).toFixed(2) + '%'
}

const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: [string, ...number[]]  = ['合计']

  columns.forEach((column: any, index: number) => {
    if (index === 0) return;

    const values = data.map((item: any) => Number(item[column.property]))
    if (!values.every((value: string | number) => Number.isNaN(value))) {
      sums[index] = `${values.reduce((prev: number, curr: number) => {
        const value = Number(curr)
        if (!Number.isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0).toFixed(0)}`
    } else {
      sums[index] = 'N/A'
    }
  })
  // 总开单毛利率
  sums[3] =  `${((1 - sums[2] / sums[1]) * 100 as any).toFixed(2)}%` as any
  // 总贡献
  sums[11] = sums[4] - sums[5] - sums[6] - sums[7] - sums[8] 
  // 总毛利率
  sums[12] = `${((1 - sums[5] / sums[4]) * 100 as any).toFixed(2)}%` as any
  sums[13] = sums[12]
  // 总贡献率
  sums[14] = `${((sums[11] / sums[4]) * 100 as any).toFixed(2)}%` as any
  sums[15] = sums[14]
  

  return sums.map((ele: any) => {
    if(/^\d+$/.test(ele)){
      return Math.floor(ele).toLocaleString()
    }
    return ele
  })
}
expose({
  showBalance,
  searchBalance
})

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_expand = _resolveComponent("expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "balanceSearchEle",
              ref: balanceSearchEle
            }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchBalance }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(orgBalanceData),
      "max-height": _unref(MI_height) + 20 + "px",
      "show-summary": "",
      "summary-method": getSummaries,
      "header-row-class-name": "blackHead",
      onRowDblclick: swtichPage
    }, {
      default: _withCtx(() => [
        (!__props.isTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              "class-name": "columnAreaDate",
              label: "月度",
              prop: "date",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(row.date).format('YYYY年MM月')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.isTotal)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              "class-name": "columnAreaDate",
              label: "团队列表",
              prop: "orgName",
              "show-overflow-tooltip": ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "开单",
          prop: "openOrder",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.openOrder)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple",
          align: "right",
          label: "交付成本",
          prop: "confirmCost",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.confirmCost)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "开单毛利率",
          prop: "confirmProfit",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "提交",
          prop: "basicOrder",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.basicOrder)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple",
          align: "right",
          label: "成本",
          prop: "basicCost",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.basicCost)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple cursor-pointer",
          align: "right",
          label: "薪酬",
          prop: "salary",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.salary)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple cursor-pointer",
          align: "right",
          label: "房租",
          prop: "rent",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.rent)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple",
          align: "right",
          label: "报销"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              "class-name": "columnAreaPurple",
              align: "right",
              label: "报销中",
              prop: "reimbursing",
              formatter: (row) => formatNumb(row.reimbursing)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              "class-name": "columnAreaPurple",
              align: "right",
              label: "已支付",
              prop: "reimbursed",
              formatter: (row) => formatNumb(row.reimbursed)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaPurple",
          align: "right",
          label: "其他",
          prop: "other",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.other)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "贡献",
          prop: "contribution",
          "show-overflow-tooltip": "",
          formatter: (row) => formatNumb(row.contribution)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "毛利率",
          prop: "profit",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "累计毛利率",
          prop: "profitTotal",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "贡献率",
          prop: "contributionRate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "columnAreaGreen",
          align: "right",
          label: "累计贡献率",
          prop: "contributionRateTotal",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowOrderQuery.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowOrderQuery).value = $event)),
      title: "订单(可按ESC关闭)",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(OrderQuery, {
          readTableOnly: true,
          ref_key: "orderQueryEle",
          ref: orderQueryEle
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowRtList.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isShowRtList).value = $event)),
      title: "成本(可按ESC关闭)",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(RtList, {
          readTableOnly: true,
          ref_key: "rtListEle",
          ref: rtListEle
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "薪酬",
      modelValue: salaryFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((salaryFg).value = $event)),
      fullscreen: true
    }, {
      default: _withCtx(() => [
        (salaryFg.value)
          ? (_openBlock(), _createBlock(salaryMonth, {
              key: 0,
              ref: "salaryElement",
              "basic-api": _unref(salaryApi),
              showPersonalColumn: false,
              "basic-params": _unref(salaryParams),
              "basic-search-config": [{
          label: '姓名', value: '', upKey: 'key'
        }]
            }, {
              columnHead: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "员工",
                  prop: "userName",
                  fixed: "",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.userName + ' (' + row.alias + ')'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "财务岗位",
                  prop: "position",
                  width: "100"
                })
              ]),
              columnEnd: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "单位社保" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _hoisted_2,
                      _createVNode(_component_el_icon, {
                        class: "column-icon",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (insureFg.value = !insureFg.value))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_expand)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "总计",
                      prop: "companySocialSecurity",
                      width: "120"
                    }, null, 8, ["formatter"]),
                    (insureFg.value)
                      ? (_openBlock(), _createBlock(_component_el_table_column, {
                          key: 0,
                          label: "Details"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位养老保险",
                              prop: "companyEndowment",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位医疗保险",
                              prop: "companyMedical",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位工伤保险",
                              prop: "companyInjury",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位生育保险",
                              prop: "companyMaternity",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位失业保险",
                              prop: "companyUnemployment",
                              width: "120"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              align: "right",
                              formatter: _unref(formatNumber),
                              label: "单位公积金",
                              prop: "companyHousing",
                              width: "120"
                            }, null, 8, ["formatter"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["basic-api", "basic-params"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowRent.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowRent).value = $event)),
      title: "租赁(可按ESC关闭)",
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(rentTbData),
          "max-height": '700px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "团队名称",
              prop: "orgName"
            }),
            _createVNode(_component_el_table_column, {
              label: "在职人数",
              prop: "peopleQuantity",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "房租",
              prop: "rentFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "物管费",
              prop: "pmFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "水电费",
              prop: "utilitiesFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "其他费用",
              prop: "otherFee",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "总计",
              prop: "total",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})